import { makeStyles } from "@material-ui/core";

const EditionListStyle = makeStyles(theme => ({
    buttonAddNewLine: {
        color: '#2D72D2',
        padding: 0,
        fontSize: '15px',
        fontWeight: 500,
        width: '50%',
        justifyContent: 'center',
        height: '32px'
    },

    itemEdition: {
        height: '100%',
        boxShadow: '0px -1px 0px 0px #E3E5E8 inset',
    },

    tableCellActionItem: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    
    buttonShowVersionLine: {
        color: '#2D72D2',
        padding: '0px 10px',
        fontSize: '15px',
        fontWeight: 500,
        justifyContent: 'center',
        height: '32px'
    },
    
    tableCellActionItemVersion: {
        justifyContent: 'space-between',
        paddingLeft: '16px',
        display: 'flex',
        height: '56px'
    },
    tableCellItemProduct: {
        maxWidth: '300px',
    },
    tableCellItemVersion: {
        maxWidth: '100px'
    }
}));

export { EditionListStyle };